import React from 'react'
import styled from '@emotion/styled'
import { colors } from '../../tokens/colors'
import { typography } from '../../tokens/typography'

export type ChipProps = {
  text: string
  icon?: React.ReactNode
  iconColor?: string
  backgroundColor?: string
  variant?: 'general' | 'success' | 'warning' | 'error'
}

export const Chip = ({
  icon,
  iconColor,
  backgroundColor,
  text,
  variant,
}: ChipProps) => {
  let backgroundColorWithType
  let iconColorWithType

  switch (variant) {
    case 'general':
      backgroundColorWithType = colors.background.tertiaryBackground
      iconColorWithType = colors.interactive.disabledDark
      break
    case 'success':
      backgroundColorWithType = colors.feedback.successLight
      iconColorWithType = colors.feedback.successDark
      break
    case 'warning':
      backgroundColorWithType = colors.feedback.warningLight
      iconColorWithType = colors.feedback.warningDark
      break
    case 'error':
      backgroundColorWithType = colors.feedback.errorLight
      iconColorWithType = colors.feedback.errorDark
      break
    default:
      backgroundColorWithType =
        backgroundColor || colors.background.tertiaryBackground
      iconColorWithType = iconColor || colors.interactive.disabledDark
      break
  }

  return (
    <ChipComponent
      iconColor={iconColorWithType}
      icon={icon}
      backgroundColor={backgroundColorWithType}
    >
      {icon && icon}
      {text}
    </ChipComponent>
  )
}

const ChipComponent = styled.div<{
  iconColor?: string
  icon?: React.ReactNode
  backgroundColor?: string
}>`
  color: ${colors.copy.headerDark};
  padding: ${({ icon }) => (icon ? '2px 6px' : '0px 4px')};
  background-color: ${({ backgroundColor }) => backgroundColor};
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 4px;
  gap: 4px;
  ${({ icon }) =>
    icon
      ? typography.down1.regularSans.styles
      : typography.down2.regularSans.styles};
  & svg {
    color: ${({ iconColor }) => iconColor};
  }
  & .MuiSvgIcon-root {
    font-size: 15px;
  }
`
